var $b26f22384b3c1526$exports = {};
$b26f22384b3c1526$exports = {
  "ascending": "\u905E\u589E",
  "ascendingSort": function ascendingSort(args) {
    return "\u5DF2\u4F9D\u64DA\u300C".concat(args.columnName, "\u300D\u6B04\u905E\u589E\u6392\u5E8F");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " \u50CF\u7D20");
  },
  "descending": "\u905E\u6E1B",
  "descendingSort": function descendingSort(args) {
    return "\u5DF2\u4F9D\u64DA\u300C".concat(args.columnName, "\u300D\u6B04\u905E\u6E1B\u6392\u5E8F");
  },
  "resizerDescription": "\u6309 Enter \u9375\u4EE5\u958B\u59CB\u8ABF\u6574\u5927\u5C0F",
  "select": "\u9078\u53D6",
  "selectAll": "\u5168\u9078",
  "sortable": "\u53EF\u6392\u5E8F\u7684\u6B04"
};
export { $b26f22384b3c1526$exports as default };